import { PATH } from 'shared';
export const BASE_PATH_EDS = PATH.CREDIT_PORTAL + PATH.CREDIT_APPLICATION + PATH.EDS.BASE;
